<template>
  <div class="Wishdetail">
    <!-- 头部区域 -->
    <van-pull-refresh v-model="isDownLoading" @refresh="onRefresh">
      <div class="header">
        <img
          class="header_bg"
          src="http://img.wish.hebyun.com.cn/images/interactWish_banner.png"
        />
      </div>

      <!-- 内容区 -->
      <div class="contents">
        <div class="contents_infos">
          <div class="list_avatar">
            <img :src="info.userinfo.avatar" />
          </div>
          <div class="list_contents">
            <!-- 姓名区 -->
            <div class="list_infos">
              <div class="list_infos_left">
                <div class="list_name_section">
                  <span class="list_name">{{ info.userinfo.nick_name }}</span>
                  <img
                    @click="jumpMyPrivate(info.userinfo.id)"
                    class="private_letter_btn"
                    src="http://img.wish.hebyun.com.cn/images/private_letter.png"
                  />
                  <div class="help_btn" style="display: none">帮他完成心愿</div>
                  <div class="help_btn helped_btn">
                    <img
                      v-if="info.wish.state === 2"
                      src="http://img.wish.hebyun.com.cn/images/sure.png"
                    />
                    <span v-if="info.wish.state === 0">审核中</span>
                    <span v-if="info.wish.state === 1">待认领</span>
                    <span v-if="info.wish.state === 2">进行中</span>
                    <span v-if="info.wish.state === 3">已完成</span>
                    <span v-if="info.wish.state === 4">已评价</span>
                  </div>
                </div>
                <div class="list_address">
                  {{ info.wish.city }}·{{ info.wish.area }}
                </div>
              </div>
              <div class="list_infos_right" v-if="info.wish.is_top === 1">
                <img src="http://img.wish.hebyun.com.cn/images/hot.png" />
              </div>
            </div>
          </div>
        </div>
        <!-- 内容区 -->
        <div class="list_des_section">
          <div class="list_des">
            {{ info.wish.content }}
          </div>
          <div class="review_bottom" v-if="info.imglist.length > 0">
            <div class="imgs">
              <div
                v-for="(img, index) in info.imglist"
                :key="index"
                class="img_box"
              >
                <img v-if="img.type === 1" :src="img.file_url" />
                <video v-if="img.type === 2" :src="img.file_url"></video>
              </div>
            </div>
          </div>
        </div>
        <div class="list_funs_time">{{ info.wish.add_time }}</div>

        <!-- 心愿详情进度 -->
        <div class="progressTitle" v-if="info.claim_userlist.length > 0">
          · 心愿详情进度 ·
        </div>
        <div class="progress_box" v-if="info.claim_userlist.length > 0">
          <ToggleDetail :list="info.claim_userlist" @partyClick="toggleParty">
            <Progress slot="content" :list="progressList" :isHideMore="true" />
            <Button
              :button="button"
              v-if="currentUserId == currentPartyId"
              slot="content"
              @click.native="jumpUpdate"
            />
          </ToggleDetail>
        </div>
        <!-- 认领按钮 -->
        <Button
          v-if="isShowClaiButton"
          :button="claiButton"
          class="claiButton"
          slot="content"
          @click.native="claimWish"
        />
        <Button
          v-if="userinfo.type == 1"
          :button="claiButton"
          class="claiButton"
          slot="content"
          @click.native="usermWish"
        />
        <!-- 审核中按钮 -->
        <div
          class="progress_btn"
          v-if="isShowProBtn && info.userinfo.type == 2"
        >
          审核中
        </div>
        <!-- 评论区 -->
        <div class="list_comments" v-if="commentslist.length > 0">
          <div class="list_comments_header">
            <img
              src="http://img.wish.hebyun.com.cn/images/comment_title.png"
              alt=""
            />
          </div>
          <div class="list_comment_items">
            <Comment :list="commentslist" :module="module" :id="info.wish.id" />
          </div>
          <!-- 查看全部评论 -->
          <div
            class="moreComment"
            v-if="commentslist.length >= 2"
            @click="jumpComments"
          >
            <span>查看全部</span>
            <img
              src="http://img.wish.hebyun.com.cn/images/right_arrow.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </van-pull-refresh>
    <Footer
      :comment_count="info.comment_count"
      :pagetype="wishPage"
      :module="'wish'"
      :id="info.wish.id"
      :is_collect="info.is_collect"
      @refresh="refresh"
    />

    <div class="side_bars" v-if="isLogin()">
      <img
        src="http://img.wish.hebyun.com.cn/images/share_icon.png"
        @click="share"
      />
      <img
        src="http://img.wish.hebyun.com.cn/images/return_con.png"
        v-if="isFirstPage"
        @click="goback"
      />
    </div>
  </div>
</template>

<script>
import ToggleDetail from "@/components/Toggle_detail";
import Progress from "@/components/Progress";
import Comment from "@/components/Comment";
import Footer from "@/components/Footer";
import Button from "@/components/Button";
import { Toast } from "vant";

export default {
  name: "wishDetail",
  components: { ToggleDetail, Progress, Comment, Footer, Button },
  data() {
    return {
      show: false,
      id: "",
      wishPage: "wishPage",
      module: "wish",
      info: {
        userinfo: {},
        wish: {},
        imglist: [],
        claim_userlist: [],
      },
      userinfo: {},
      commentslist: [], //评论数据
      page: 1,
      limit: 3,
      message: "",
      button: "更新进度",
      claiButton: "认领心愿",
      progressList: [],
      currentPartyId: "", //当前选中的党员id
      currentUserId: "", //当前用户id
      isShowClaiButton: true,

      isFirstPage: false,
      isShowProBtn: false, //是否展示审核中
      isDownLoading: false, // 下拉刷新
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.queryInfo(this.id);
    this.queryComments();
    if (this.isLogin()) {
      this.queryUserInfo();
    }
    let isFirstPage = localStorage.getItem("isFirstPage");
    if (isFirstPage == "0") {
      this.isFirstPage = true;
    }
  },
  mounted() {
    Toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 0,
    });
  },
  methods: {
    // 下拉加载
    onRefresh() {
      this.queryInfo(this.id);
      this.queryComments();
      this.$toast("刷新成功");
      this.isDownLoading = false;
    },
    goback() {
      this.$router.go(-1);
    },
    share() {
      var url = window.location.href;

      var msg = {
        shareTitle: "我为群众办实事 党员帮办微心愿",
        shareSummary: "提交心愿、认领心愿、互动点赞，请登录“冀云”客户端",
        shareUrl: url,
        shareImage: "http://img.wish.hebyun.com.cn/images/wyxShare.jpg",
      };
      const u = navigator.userAgent,
        app = navigator.appVersion;
      console.log(app);
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        window.webkit.messageHandlers.nativeShare.postMessage(
          JSON.stringify(msg)
        );
      } else {
        window.jsInterface.nativeShare(JSON.stringify(msg));
      }
    },
    // 查询用户信息
    async queryUserInfo() {
      let { data } = await this.$api.queryUserInfo();
      this.userinfo = data;
    },
    // 分页查询评论
    async queryComments() {
      let params = {
        page: this.page,
        limit: this.limit,
        module: this.module,
        id: this.id,
      };
      let { data } = await this.$api.queryComments(params);

      data.forEach((item) => {
        item.is_thumb = 0;
      });
      this.commentslist = data;
    },

    // 查询某个心愿详情
    async queryInfo(id) {
      let { data } = await this.$api.queryWishDetail(id);
      this.info = data;
      this.currentUserId = this.info.curentUserId;
      if (this.info.is_canclaim == 1) {
        this.isShowClaiButton = true;
      } else {
        this.isShowClaiButton = false;
      }
      // 查询进度
      if (this.info.claim_userlist.length > 0) {
        this.currentPartyId = this.info.claim_userlist[0].id;
        this.queryProgress(this.id, this.currentPartyId);
      }
      Toast.clear();
    },

    // 更新进度
    updateProgress() {
      this.$router.push("/updateProgress");
    },

    // 查询某个心愿中某个党员或机构的进度 wishid:心愿id  user_id:党员或机构用户id，如果0表示当前用户
    async queryProgress(id, user_id) {
      let datas = {
        wishid: id,
        user_id: user_id,
      };
      let { data } = await this.$api.queryProcess(datas);
      this.progressList = data;
    },

    //切换党员
    toggleParty(partyInfo) {
      this.currentPartyId = partyInfo.id;
      console.log("this.currentPartyId =" + this.currentPartyId);
      this.queryProgress(this.id, partyInfo.id);
    },

    // 点击私信图标
    jumpMyPrivate(id) {
      setTimeout(() => {
        this.$router.push({
          path: "/privateDetail",
          query: { id: id },
        });
      }, 250);
    },

    // 更新进度
    jumpUpdate() {
      this.$router.push({
        path: "/update",
        query: { id: this.id },
      });
    },

    // 更新页面
    refresh() {
      this.queryInfo(this.id);
    },

    // 查看全部评论
    jumpComments() {
      if (this.isLogin()) {
        this.$router.push({
          path: "./comments",
          query: {
            id: this.id,
            module: "wish",
          },
        });
      } else {
        window.location.href =
          "https://a.app.qq.com/o/simple.jsp?pkgname=com.hbrb.jiyun";
      }
    },

    // 认领心愿 增加身份判断
    claimWish() {
      let data = {
        wishid: this.id,
      };
      // if
      // this.info.userinfo.type
      // type 1 {
      //   this.$dialog 您当前不是党员 需要认证才可以认领 去register
      //

      // else

      this.$dialog
        .confirm({
          message: "确定认领该心愿吗",
        })
        .then(async () => {
          let res = await this.$api.claimWish(data);
          console.log(res);
          if (res.code == "0") {
            if (this.info.userinfo.type == 3) {
              this.$toast("认领成功");
              this.isShowClaiButton = false;
            } else if (this.info.userinfo.type == 2) {
              this.$toast("认领申请已提交，等待管理员审核");
              this.isShowClaiButton = false;
              this.isShowProBtn = true;
            }
            this.queryInfo(this.id);
          }
        });
    },
    usermWish() {
      let that = this;
      this.$dialog
        .confirm({
          message: "您不是党员，请认证党员后认领",
        })
        .then(async () => {
          that.$router.push("/register");
        });
    },
  },
};
</script>

<style lang="scss">
.progress_box {
  .toggle {
    width: 100%;
  }
  .progress {
    width: 335px;
  }
  /deep/.van-tabs__content .btn {
    margin-top: 20px;
  }
}
.Wishdetail {
  .btn {
    position: static;
    width: 130px;
    height: 30px;
    margin: 0px auto;

    span {
      font-size: 15px;
    }
  }
  .contents .claiButton {
    bottom: 0;
    position: static;
  }
}
</style>
<style scoped lang="scss">
.Wishdetail {
  width: 100%;
  background-color: rgba(175, 31, 36, 1);
  min-height: 100vh;
  /* 头部区域 */
  .header {
    position: relative;
    width: 100%;
    height: 110px;

    .header_bg {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 0;
      height: auto;
    }
  }
  /* 内容区 */
  .contents {
    position: relative;
    width: 355px;
    height: auto;
    min-height: calc(100vh - 175px);
    background-color: #f9f1c6;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    // z-index: 1;
    padding: 5px 10px 80px;
    box-sizing: border-box;
    margin: 0 auto;
    .progress_btn {
      width: 130px;
      height: 30px;
      background-color: #dcdcdc;
      border-radius: 30px;
      font-size: 15px;
      line-height: 30px;
      color: #999999;
      margin: 10px auto 0;
    }
    .contents_infos {
      display: flex;
      align-items: center;
      .list_avatar {
        margin-right: 9.5px;
        width: 31px;
        height: 31px;
        img {
          width: 31px;
          height: 31px;
          border-radius: 50%;
          object-fit: cover;
        }
      }
      .list_contents {
        width: 294px;
        .list_infos {
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-sizing: border-box;
          width: 100%;
          .list_infos_left {
            .list_name_section {
              display: inline-flex;
              align-items: center;
              margin-bottom: 5px;
              .list_name {
                font-size: 18px;
                color: #333333;
              }
              .private_letter_btn {
                width: 15px;
                height: 11px;
                padding: 0 5px;
              }
              .help_btn {
                color: #e50012;
                text-align: center;
                width: 63px;
                height: 16px;
                background-color: #f42e21;
                border-radius: 10px;
                font-size: 12px;
                color: #f9f1c6;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 16px;
                padding-top: 1px;
                img {
                  width: 11.5px;
                  height: 10px;
                }
              }
            }
            .list_address {
              font-size: 12px;
              color: #666666;
              line-height: 1;
              padding-bottom: 10px;
              text-align: left;
            }
          }
          .list_infos_right {
            width: 13px;
            img {
              width: 13px;
              height: 16px;
            }
          }
        }
      }
    }
    /* 内容区 */
    .list_des_section {
      position: relative;
      margin-bottom: 10px;
      .list_des {
        font-size: 16px;
        line-height: 1.5;
        color: #333333;
        text-align: left;
      }
      .review_bottom {
        // padding: 0 11px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 9.5px;
        box-sizing: border-box;
        /* 图片区域 */
        .imgs {
          width: 100%;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          .img_box {
            flex: 1;
            img {
              width: 100%;
              border-radius: 10px;
              margin-right: 10px;
              object-fit: cover;
            }
          }
          .img_box:nth-child(3n) {
            margin-right: 0;
          }
        }
      }
    }

    .list_funs_time {
      margin-bottom: 10px;
      padding-top: 10px;
      border-top: 1px dashed rgba(229, 0, 18, 0.5);
      font-size: 12px;
      color: #999999;
      text-align: left;
    }

    /* 心愿详情进度 */
    .progressTitle {
      font-size: 17px;
      line-height: 20.5px;
      color: #e60012;
      font-weight: 800;
      text-align: center;
      padding: 25px 0;
      margin: 0 15px;
      box-sizing: border-box;
      // border-top: 2px dashed rgba(229, 0, 18, 0.3);
    }
    .progress_box {
      width: 335px;
      border-radius: 10px;
      margin: 0 auto 28px;
      border: solid 1px #e4806f;
      border-top: 0;
      border-radius: 10px;
      padding-bottom: 30px;
      box-sizing: border-box;
      .btn {
        img {
          border-radius: 15px;
        }
      }
    }
    /* 评论区 */
    .list_comments {
      width: 100%;
      height: auto;
      border-radius: 10px;
      padding: 15px 0;
      box-sizing: border-box;
      margin-bottom: 21.5px;
      border-radius: 20px 20px 0 0;
      .list_comments_header {
        img {
          width: 72px;
        }
      }
      .moreComment {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 20px;
        span {
          font-size: 14px;
          letter-spacing: 1px;
          color: #555;
          margin-right: 4px;
          line-height: 1;
        }
        img {
          width: 6px;
          vertical-align: middle;
        }
      }
    }
    .btn {
      bottom: 55px;
      img {
        border-radius: 15px;
      }
    }
  }
}
/* 底部固定区 */
.footer_bar {
  z-index: 1000;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  width: 375px;
  height: 55px;
  background-color: #ffffff;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
  input {
    width: 233px;
    height: 38px;
    background-color: #f6f6f6;
    border-radius: 38px;
    font-size: 14px;
    line-height: 38px;
    letter-spacing: 0.5px;
    color: #333333;
    padding-left: 19px;
    box-sizing: border-box;
    outline: none;
    border: none;
  }
}

.footer_right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .comment {
    position: relative;
    img {
      width: 19px;
      height: 18.5px;
    }
    .red {
      position: absolute;
      right: -6px;
      top: -7px;
      min-width: 14px;
      height: 14px;
      background-color: #ff0000;
      font-size: 11px;
      line-height: 14px;
      letter-spacing: 0.5px;
      color: #fffefe;
      border-radius: 10px;
    }
  }
  .collect {
    margin: 0 18px;
    img {
      width: 24px;
      height: 23px;
    }
  }
  .share {
    img {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
